<template>
  <div class="ability-assessment">
    <!-- 筛选和搜索区域 -->
    <div class="search">
      <el-form label-width="80px">
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="状态:" @change="handleStatusChange">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form label-width="80px">
        <el-form-item label="搜索">
          <div style="display: flex;align-items: center;flex-direction: row;justify-content: flex-start;">
            <el-select v-model="queryType" placeholder="搜索" style="margin-right: 10px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="申请人ID" value="1"></el-option>
              <el-option label="申请人昵称" value="2"></el-option>
            </el-select>
            <el-input style="width: 200px;" v-model="queryContent" placeholder="请输入搜索内容"></el-input>
            <img class="search-icon" src="/img/search-icon.png" @click="handleSearch" />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表区域 -->
    <div class="list-container">
      <div v-for="item in assessmentList" :key="item.id" class="assessment-item">
        <div class="item-header">
          <div class="item-info">
            <div class="info-row">
              <span class="label">申请人ID:</span>
              <span class="value">{{ item.applicateUserPhone }}</span>
            </div>
            <div class="info-row">
              <span class="label">申请人昵称:</span>
              <span class="value">{{ item.applicateUserNiceName }}</span>
            </div>
            <div class="info-row">
              <span class="label">详情页:</span>
              <span class="value">
                <el-button type="text" @click="openConsultDetail(item.consultantId)">查看</el-button>
              </span>
            </div>
          </div>
        </div>

        <!-- 申请时间和状态信息 -->
        <div class="status-info">
          <div class="info-row">
            <span class="label">申请时间:</span>
            <span class="value">{{ item.createTime }}</span>
          </div>

          <!-- 评定结果 -->
          <div class="info-row">
            <span class="label">评定结果:</span>
            <span class="value">
              <el-select
                v-if="item.status === 0"
                v-model="assessmentResults[item.id]"
                placeholder="请选择"
                style="width: 200px;"
              >
                <el-option label="请选择" value=""></el-option>
                <el-option label="很低" value="-3"></el-option>
                <el-option label="较低" value="-2"></el-option>
                <el-option label="稍低" value="-1"></el-option>
                <el-option label="中等" value="0"></el-option>
                <el-option label="良好" value="1"></el-option>
                <el-option label="优秀" value="2"></el-option>
                <el-option label="卓越" value="3"></el-option>
              </el-select>
              <span v-else>{{ getAbilityLevelText(item.abilityLevel) }}</span>
            </span>
          </div>

          <div class="info-row">
            <span class="label">状态:</span>
            <span class="value">
              <el-tag :type="getStatusType(item.status)">
                {{ getStatusText(item.status) }}
              </el-tag>
            </span>
          </div>

          <!-- 处理人 -->
          <div v-if="item.status !== 0" class="info-row">
            <span class="label">处理人:</span>
            <span class="value">{{ item.auditUserName || item.auditUserId }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div v-if="item.status === 0" class="action-buttons">
          <el-button type="primary" @click="handleProcess(item)">置已处理</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAbilityAssessmentList, abilityAssessmentPassed} from '../../api/background'

export default {
  name: 'AbilityAssessment',
  props: {
    needList: {
      type: Array,
      default: () => []
    },
    pageNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      assessmentList: [],
      status: '-1',
      queryType: '-1',
      queryContent: '',
      assessmentResults: {} // 存储每个申请的评定结果
    }
  },
  watch: {
    // status() {
    //   this.getAssessmentList(1)
    // },
    queryType() {
      this.getAssessmentList(this.pageNum)
    },
    pageNum(val) {
      this.getAssessmentList(val)
    }
  },
  created() {
    this.getAssessmentList(this.pageNum)

  },
  methods: {
    // 获取能力评定列表
    getAssessmentList(page) {
      const params = {
        status: this.status ,
        queryType: this.queryType,
        queryContent: this.queryContent,
        pageNum: page || 1
      }

      getAbilityAssessmentList(params)
        .then(res => {
          this.assessmentList = res.data.records || []
          this.$emit('updatePendingTotal', res.data.pendingTotal || 0)
        })
        .catch(err => {
          console.error('获取能力评定列表失败:', err)
          this.$message.error('获取数据失败')
        })
    },

    // 状态筛选变化
    handleStatusChange() {
      this.getAssessmentList(this.pageNum)
    },

    // 搜索
    handleSearch() {
      if (this.queryContent) {
        this.getAssessmentList(this.pageNum)
      }
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        0: 'warning', // 待处理
        1: 'success' // 已处理
      }
      return statusMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已处理'
      }
      return statusMap[status] || '未知'
    },

    // 获取能力等级文本
    getAbilityLevelText(level) {
      const levelMap = {
        '-3': '很低',
        '-2': '较低',
        '-1': '稍低',
        '0': '中等',
        '1': '良好',
        '2': '优秀',
        '3': '卓越'
      }
      return levelMap[level] || '未评定'
    },

    // 打开咨询详情页
    openConsultDetail(consultantId) {
      const routeData = this.$router.resolve({
        path: '/personalConsultDetail',
        query: {consultant_id: consultantId}
      })
      window.open(routeData.href, '_blank')
    },

    // 置已处理
    handleProcess(item) {
      const abilityLevel = this.assessmentResults[item.id]
      if (!abilityLevel && abilityLevel !== 0) {
        this.$message.error('请选择评定结果')
        return
      }

      this.$confirm('确认设置为已处理吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          abilityAssessmentPassed({
            id: item.id,
            abilityLevel: parseInt(abilityLevel)
          })
            .then(() => {
              this.$message.success('操作成功')
              this.getAssessmentList(this.pageNum)
              this.$emit('refreshNeedList')
            })
            .catch(err => {
              console.error('设置已处理失败:', err)
              this.$message.error('操作失败')
            })
        })
        .catch(() => {
          // 用户取消
        })
    }
  }
}
</script>

<style scoped>
.ability-assessment {
  padding: 20px;
}

.search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.search-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 20px;
}

.list-container {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.assessment-item {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  padding: 20px;
}

.assessment-item:last-child {
  border-bottom: 1px solid #e4e7ed;
}

.item-header {
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.label {
  min-width: 100px;
  font-weight: 500;
  color: #606266;
}

.value {
  color: #303133;
  flex: 1;
}

.status-info {
  margin: 15px 0;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}

.action-buttons .el-button {
  margin-left: 10px;
}
</style>
